
import React, { Component } from "react";
import { connect } from 'react-redux';
import { hospitalActions, userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import Timer from 'otp-timer'
import Logo from '../../images/1.png'
import { authHeader } from "../../_helpers";
import { CONST } from "../../_config";
import OtpInput from 'react-otp-input';
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';


class Signup extends Component {
  constructor(props) {
    super(props);
    this.registerSubmit = this.registerSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.state = {
      fieldslogin: {},
      errorslogin: {},
      otp: '',
      passwordVisible: false,
      passwordVisibleConfirm: false,
      condition: false
    }
  }

  handleOtpChange = otp => {
    this.setState({ otp });
  };

  handleCheckboxChange = () => {
    this.setState(prevState => ({
      condition: !prevState.condition
    }));

  };


  inputChange(e) {
    e.preventDefault();
    let { name, value } = e.target;
    this.setState({ [name]: value });
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = this.state.errorslogin;
    fieldslogin[name] = value;
    errorslogin[name] = "";
    this.setState({ fieldslogin, errorslogin });
  }

  registerSubmit(e) {
    e.preventDefault();

    if (this.state.condition) {
      if (this.handleValidationLogin()) {
        let data = {
          hospitalName: this.state.fieldslogin.userName,
          email: this.state.fieldslogin.email,
          password: this.state.fieldslogin.password,
          confirmPassword: this.state.fieldslogin.confirmPassword,
        }
        this.props.dispatch(hospitalActions.register(data, this.props));
      }
    } else {
      alert("Accept Terms & Conditions")
    }



  }

  resendOtpSubmit = (e) => {
    if (this.handleValidationLogin()) {
      let data = {
        hospitalName: this.state.fieldslogin.userName,
        email: this.state.fieldslogin.email,
        password: this.state.fieldslogin.password,
        confirmPassword: this.state.fieldslogin.confirmPassword,
      }
      this.props.dispatch(hospitalActions.register(data, this.props));
    }
  }


  otpSubmit = (e) => {
    e.preventDefault();
    if (this.handleValidationOTP()) {
      let { userToken } = this.props.registeruser;
      let { OTP } = this.state;
      this.props.dispatch(hospitalActions.registerValidateOtp({
        token: userToken,
        otp: OTP
      }, this.props));
    }
  }

  resetForm = (e) => {
    e.preventDefault();
    this.setState({
      fieldslogin: {},
      errorslogin: {},
    })
    this.hideErrorMessage();
  }

  handleValidationOTP = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //Name
    if (!fieldslogin["OTP"]) {
      formIsValid = false;
      errorslogin["OTP"] = "please Enter OTP!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }



  handleValidationLogin = () => {
    const { fieldslogin } = this.state;
    let errorslogin = {};
    let formIsValid = true;

    // Validate UserName
    if (!fieldslogin.userName || fieldslogin.userName === "") {
      formIsValid = false;
      errorslogin.userName = "Hospital Name cannot be empty";
    }
    // Validate Email
    if (!fieldslogin.email || fieldslogin.email === "") {
      formIsValid = false;
      errorslogin.email = "Email cannot be empty";
    } else {
      const lastAtPos = fieldslogin.email.lastIndexOf('@');
      const lastDotPos = fieldslogin.email.lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fieldslogin.email.indexOf('@@') === -1 && lastDotPos > 2 && (fieldslogin.email.length - lastDotPos) > 2)) {
        formIsValid = false;
        errorslogin.email = "Enter a valid Email address";
      }
    }

    // Validate Password
    if (!fieldslogin.password || fieldslogin.password.length < 8) {
      formIsValid = false;
      errorslogin.password = "Password must be at least 8 characters long";
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}/.test(fieldslogin.password)) {
      formIsValid = false;
      errorslogin.password = "Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character";
      // errorslogin.password = "";
    }

    // Validate Confirm Password
    if (!fieldslogin.confirmPassword) {
      formIsValid = false;
      errorslogin.confirmPassword = "Confirm Password cannot be empty";
    }

    if(fieldslogin.confirmPassword !== fieldslogin.password){
      formIsValid = false;
      errorslogin.confirmPassword = "Passwords do not match";
    }
    this.setState({ errorslogin });
    return formIsValid;
  }



  inputChangeReferal = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    if (value.length === 8) {
      this.props.dispatch(userActions.getUserByRefCode({ refCode: value }));
    }
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = this.state.errorslogin;
    fieldslogin[name] = value;
    errorslogin[name] = "";
    this.setState({ fieldslogin, errorslogin });
  }


  componentDidMount() {

    this.props.dispatch(hospitalActions.resetdata())
    let data = "";
    data = this.props.match.params.id ? this.props.match.params.id : "!!!!"
    if (this.props.match.params.id) {
      this.props.dispatch(userActions.getUserByRefCode({ refCode: this.props.match.params.id }));

    }
  }

  onClickMenu = (url) => {
    this.props.history.push(url)
  }


  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible
    }));
  };
  togglePasswordVisibilityConfirm = () => {
    this.setState(prevState => ({
      passwordVisibleConfirm: !prevState.passwordVisibleConfirm
    }));
  };


  handleClick = () => {


    window.open("https://docs.google.com/document/d/13s0Ie2z6qjeYE8PGN1EQUit3SMSGHZOq3p6rXEQ4hfY/edit", "_blank")
  }
  render() {
    let { otpSentRegister, loading, users, hospital } = this.props;
    let { showOtp } = hospital
    const { otp } = this.state;
    let { userByRefCode } = users;
    const { errorslogin, passwordVisible, passwordVisibleConfirm } = this.state;
    return (
      <>
        <div >
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        {/* Whole Structure */}
        <div className="overflow-y-auto">
          {/*Header Section */}
          <div className="bg-cover bg-no-repeat overflow-y-auto bg-[#95CCC5]" >
            <div className="h-screen flex flex-col justify-center py-12 px-3 sm:px-6 lg:px-8 z-20  overflow-y-auto">
              <div className="mx-auto w-full  max-w-[50rem]">
                <div className="bg-dark relative border border-gray-800 bg-slate-200 shadow rounded-3xl px-5 sm:px-12">
                  <Link to="/" className=" absolute top-3 left-5 text-xl text-[#005F60] cursor-pointer" >

                    <FaHome />

                  </Link>

                  <div className="justify-between lg:flex py-4 space-y-2 lg:space-x-2 space-x-0 lg:space-y-0">
                    <button onClick={() => this.onClickMenu('/physio/signup')} className=" w-full py-3 px-5 text-[#005F60] bg-white rounded-md capitalize text-xl  font-bold">Register as physio</button>
                    <button onClick={() => this.onClickMenu('/hospital/signup')} className=" w-full py-3 px-5 bg-[#ED117F] text-white rounded-md capitalize text-xl  font-bold">Register as Hospital / Clinic</button>

                  </div>
                  <form autoComplete="off" className="grid lg:grid-cols-2 grid-cols-1 gap-4 py-4">
                    <div className="">
                      <label className="text-[#005F60] font-bold text-sm"> Name</label>
                      <div className=" rounded-md shadow-sm ">
                        <input disabled={showOtp ? true : false} className={`appearance-none block w-full px-4 pl-4 py-2 h-12 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["userName"] ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700" : "border-opacity-100 border border-red-500"}`}
                          id="userName" name="userName" placeholder="Hospital Name" type="text" onChange={this.inputChange} />
                        {this.state.errorslogin["userName"] ?
                          <div className="invalid-feedback text-red-600">
                            {this.state.errorslogin["userName"]}
                          </div>
                          : null}
                      </div>
                    </div>

                    <div className="">
                      <label className="text-[#005F60] font-bold text-sm">Email</label>
                      <div className=" rounded-md shadow-sm ">
                        <input disabled={showOtp ? true : false} className={`appearance-none block w-full px-4 pl-4 py-2 h-12 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["email"] ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700" : "border-opacity-100 border border-red-500"}`}
                          id="email" name="email" placeholder="Email" type="email" onChange={this.inputChange} />
                        {this.state.errorslogin["email"] ?
                          <div className="invalid-feedback text-red-600">
                            {this.state.errorslogin["email"]}
                          </div>
                          : null}
                      </div>
                    </div>
                    <div className="">
                      <label className="text-[#005F60] font-bold text-sm">Password</label>
                      <div className="relative rounded-md shadow-sm">
                        <input
                          disabled={showOtp ? true : false}
                          className={`appearance-none block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["password"]
                            ? " border-opacity-100 border placeholder-gray-700"
                            : "border-opacity-100 border border-red-500"
                            }`}
                          id="password"
                          name="password"
                          placeholder="Password"
                          type={passwordVisible ? "text" : "password"}
                          onChange={this.inputChange}
                        />
                        {this.state.errorslogin["password"] && (
                          <div className="invalid-feedback text-xs text-red-600">
                            {this.state.errorslogin["password"]}
                          </div>
                        )}
                        <span className="absolute top-5 right-3 text-gray-400 cursor-pointer" onClick={this.togglePasswordVisibility}>
                          {passwordVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                        </span>
                      </div>
                    </div>

                    <div className="">
                      <label className="text-[#005F60] font-bold text-sm">Confirm Password</label>
                      <div className="relative rounded-md shadow-sm">
                        <input
                          disabled={showOtp ? true : false}
                          className={`appearance-none block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["confirmPassword"]
                            ? "border-opacity-100 border placeholder-gray-700"
                            : "border-opacity-100 border border-red-500"
                            }`}
                          id="confirmPassword"
                          name="confirmPassword"
                          placeholder="Confirm Password"
                          type={passwordVisibleConfirm ? "text" : "password"}
                          onChange={this.inputChange}
                        />
                        {this.state.errorslogin["confirmPassword"] && (
                          <div className="invalid-feedback text-red-600">
                            {this.state.errorslogin["confirmPassword"]}
                          </div>
                        )}
                        <span className="absolute top-5 right-3 text-gray-400 cursor-pointer" onClick={this.togglePasswordVisibilityConfirm}>
                          {passwordVisibleConfirm ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                        </span>
                      </div>
                    </div>



                    {
                      showOtp ?

                        <div className="">
                          <label className="text-[#005F60] font-bold text-sm">OTP <span className=" text-black font-normal text-sm">sent to {this.state.fieldslogin.email}</span></label>
                          <div className=" rounded-md shadow-sm ">
                            <input maxLength="6" className={`appearance-none block w-full px-4 pl-4 py-2 h-12 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["OTP"] ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700" : "border-opacity-100 border border-red-500"}`}
                              id="OTP" name="OTP" placeholder="Enter OTP" type="number" onChange={this.inputChange} />
                            {this.state.errorslogin["OTP"] ?
                              <div className="invalid-feedback text-red-600">
                                {this.state.errorslogin["OTP"]}
                              </div>
                              : null}
                          </div>
                        </div>
                        : null
                    }


                  </form>
                  {showOtp ?
                    <div className="">
                      <Timer
                        textColor={"#005F60"}
                        seconds={1}
                        minutes={2}
                        ButtonText="Resend Otp"
                        buttonColor="#ffffff"
                        background={"#005F60"}
                        resend={this.resendOtpSubmit}
                      />
                    </div>
                    : null
                  }



                  {
                    showOtp ?
                      <div className="py-4">
                        <div className="flex items-center text-center gap-1 mb-1">

                          <input checked={this.state.condition} disabled type="checkbox" className=" border" placeholder="" />
                          <div className="text-sm">I agree to <span className=" cursor-pointer text-[#005F60]"><a href="https://urphysio.in/images1/image-1712756450101.pdf" target="_blank">Terms & Conditions</a></span> </div>

                        </div>
                        <button className="w-full mx-auto flex justify-center py-3 uppercase px-4 border text-lg  rounded-xl text-white font-bold bg-[#005F70] border-[#005F70] hover:bg-[#005F70] hover:text-white transition duration-150 ease-in-out" type="submit" onClick={this.otpSubmit}>Verify OTP</button>
                      </div>
                      :
                      <div className="py-4">
                        <div className="flex items-center text-center gap-1 mb-1">

                          <input checked={this.state.condition} onChange={this.handleCheckboxChange} type="checkbox" className=" border" placeholder="" />
                          <div className="text-sm">I agree to <span className=" cursor-pointer text-[#005F60]"><a href="https://urphysio.in/images1/image-1712756450101.pdf" target="_blank">Terms & Conditions</a></span> </div>

                        </div>
                        <button className="w-full mx-auto flex justify-center py-3 uppercase px-4 border text-lg  rounded-xl text-white  bg-[#005F60] border-[#005F60] hover:bg-[#005F70] hover:text-white font-bold transition duration-150 ease-in-out" type="submit" onClick={this.registerSubmit}>Sign up</button>
                      </div>

                  }

                  <div className="leading-5 text-center py-4">
                    <p className="text-base font-bold text-[#005F60]">Already have account?
                      <span className="cursor-pointer text-green-600 font-bold  hover:underline hover:text-shine focus:outline-none focus:underline transition ease-in-out duration-150" onClick={() => this.onClickMenu('/hospital/login')}> Sign In</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Whole Structure End*/}


      </>
    )
  }
}
function mapStateToProps(state) {
  const { loggingIn, user, otpSentRegister, registeruser, loading } = state.authentication;
  const { users, hospital } = state;
  return {
    loggingIn,
    registeruser,
    otpSentRegister,
    user,
    users,
    loading,
    hospital
  };
}
// export default connect(mapStateToProps)(Login);
export default (connect(mapStateToProps)(Signup));